import styled from 'styled-components'

export const Wrapper = styled.nav`
  background: var(--brand-secondary);
  padding: 0 25px;
  width: 100%;
  box-sizing: border-box;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* so home yellow blob does not cover topbar */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;

  + * {
    margin-top: 100px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    height: 54px;

    + * {
      margin-top: 54px;
    }
  }
`

export const MenuContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(80px, 130px) 1fr minmax(80px, 130px);
  align-items: center;
  gap: 10px;
  width: 100%;

  & > a,
  & > span {
    color: var(--white);
    font-size: 16px;
    text-decoration: none;
    margin-right: 30px;
    cursor: pointer;
  }
`

export const VirginLogo = styled.div`
  position: relative;
  width: 100%;
  height: 42px;

  > img {
    position: absolute;
    right: 0;
    top: 0;
  }

  @media (max-width: 1000px) {
    height: 100%;

    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  @media (max-width: 500px) {
    > img {
      width: 80%;
      height: 100%;
      object-fit: contain;
    }
  }
`

export const LeftLink = styled.div`
  cursor: pointer;
  color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  svg {
    width: 24px;
    height: 24px;
  }

  path,
  rect {
    stroke: white;
  }
`

export const RightLink = styled.div`
  cursor: pointer;
  color: white;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  svg {
    width: 24px;
    height: 24px;
  }

  g {
    stroke: white;
  }
`

export const Logo = styled.div`
  display: flex;
  justify-content: center;
`
